import { convertDateToNeedFormat } from './convertDateHandlers';
import { parseServerDate } from './parseServerDate';

const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

const daysFromToday = (date: Date) =>
  Math.round((startOfDay(new Date()) - startOfDay(date)) / MILLISECONDS_IN_DAY);

export const showDateFromToday = (date: string) => {
  const needDate = parseServerDate(date);
  if (!needDate) {
    return '';
  }
  if (daysFromToday(needDate) === 0) {
    return convertDateToNeedFormat({ date, format: 'time' });
  }
  return convertDateToNeedFormat({ date, format: 'datetime' });
};

const changeMonthValue = (date: string) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthIndex = parseInt(date) - 1;
  return months[monthIndex] || date;
};

const convertDayView = (date: string) => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const dayIndex = parseInt(date);
  return days[dayIndex] || date;
};

export const showDateFromTodayUpdate = (date: string) => {
  const today = new Date();
  const needDate = parseServerDate(date);

  if (!needDate) {
    return '';
  }
  const daysAgo = daysFromToday(needDate);

  if (daysAgo === 0) {
    return 'Today';
  } else if (daysAgo === 1) {
    return 'Yesterday';
  } else if (today.getFullYear() === needDate.getFullYear()) {
    return `${needDate.getDate()} ${changeMonthValue(
      `${needDate.getMonth() + 1}`,
    )}, ${convertDayView(`${needDate.getDay()}`)}`;
  } else {
    return `${needDate.getDate()} ${changeMonthValue(
      `${needDate.getMonth() + 1}`,
    )}, ${needDate.getFullYear()}`;
  }
};
